module.exports = __webpack_public_path__ + "img/客户信息补全.c17ec2a0.png";